<template>
<div class="tutorial-video" v-if="currentVideoTutorial" :style="this.currentVideoTutorial.noWidthHeightConstraints?'width: initial;':''">
  <div class="close-icon" @click="closeAction">
    <span class="material-icons">close</span>
  </div>
  <div class="video" :style="this.currentVideoTutorial.noWidthHeightConstraints?'height: initial; line-height:0;':''">
    <iframe
      v-if="videoLink"
      :src="videoLink"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    <img
      v-if="gifLink"
      :src="gifLink"
      :width="gifWidth"
      :style="this.currentVideoTutorial.noWidthHeightConstraints?'max-width: initial !important;':''"
    />
  </div>
  <div class="mt-5 video-title" v-if="title">{{ title }}</div>
  <div class="mt-3 video-time" v-if="formattedTime">{{ formattedTime }}</div>
  <div class="mt-3 video-explain" v-if="description">
    {{ description }}
  </div>
</div>
</template>

<script>
export default {
  name: 'TutorialVideo',
  data () {
    return {
      actualVideoDuration: null,
      // showTutorialModal: false,
      // title: '',
      // videoLink: '',
      // gifLink: '',
      // gifWidth: '',
      // description: '',
      // time: '',
    }
  },
  computed: {
    currentVideoTutorial() {
      return this.$store.state.currentVideoTutorial
    },
    title () {
      return this.currentVideoTutorial ? this.currentVideoTutorial.title : ''
    },
    videoLink () {
      return this.currentVideoTutorial ? this.currentVideoTutorial.videoLink : ''
    },
    gifLink () {
      return this.currentVideoTutorial ? this.currentVideoTutorial.gifLink : ''
    },
    gifWidth () {
      return this?.currentVideoTutorial?.gifWidth
    },
    description () {
      return this.currentVideoTutorial ? this.currentVideoTutorial.description : ''
    },
    time () {
      return this.currentVideoTutorial ? this.currentVideoTutorial.time : ''
    },
    formattedTime () {
      // Use actual video duration if available, otherwise fall back to stored time
      if (this.actualVideoDuration) {
        return this.formatDuration(this.actualVideoDuration)
      }
      return this.time
    }
  },
  watch: {
    videoLink: {
      immediate: true,
      handler(newLink) {
        if (newLink) {
          this.fetchVideoDuration(newLink)
        } else {
          this.actualVideoDuration = null
        }
      }
    }
  },
  mounted() {
    if (!window.YT) {
      const existingScript = document.querySelector('script[src="https://www.youtube.com/iframe_api"]')
      if (!existingScript) {
        const tag = document.createElement('script')
        tag.src = 'https://www.youtube.com/iframe_api'
        const firstScriptTag = document.getElementsByTagName('script')[0]
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
      }
      
      const originalCallback = window.onYouTubeIframeAPIReady
      
      window.onYouTubeIframeAPIReady = () => {
        if (originalCallback && typeof originalCallback === 'function') {
          originalCallback()
        }
        if (this.videoLink) {
          this.fetchVideoDuration(this.videoLink)
        }
      }
    } else if (this.videoLink) {
      this.fetchVideoDuration(this.videoLink)
    }
  },
  beforeDestroy() {
    const tempPlayers = document.querySelectorAll('[id^="temp-player-"]')
    tempPlayers.forEach(player => {
      try {
        if (window.YT && window.YT.get) {
          const ytPlayer = window.YT.get(player.id)
          if (ytPlayer && ytPlayer.destroy) {
            ytPlayer.destroy()
          }
        }
        if (player.parentNode) {
          player.parentNode.removeChild(player)
        }
      } catch (error) {
        console.error('Error cleaning up player:', error)
      }
    })
  },
  methods: {
    closeAction () {
      // this.showTutorialModal = false;
      this.$store.commit('setCurrentVideoTutorialToDisplay', null);
    },
    extractVideoId(url) {
      const match = url.match(/youtube\.com\/embed\/([^?&]+)/)
      return match ? match[1] : null
    },
    fetchVideoDuration(videoUrl) {
      const videoId = this.extractVideoId(videoUrl)
      if (!videoId) {
        this.actualVideoDuration = null
        return
      }

      this.$nextTick(() => {
        if (window.YT && window.YT.Player) {
          const tempDiv = document.createElement('div')
          tempDiv.id = `temp-player-${Date.now()}`
          tempDiv.style.display = 'none'
          document.body.appendChild(tempDiv)

          try {
            const player = new window.YT.Player(tempDiv.id, {
              videoId: videoId,
              events: {
                onReady: (event) => {
                  const duration = event.target.getDuration()
                  if (duration && duration > 0) {
                    this.actualVideoDuration = duration
                  }
                  event.target.destroy()
                  document.body.removeChild(tempDiv)
                },
                onError: () => {
                  document.body.removeChild(tempDiv)
                }
              }
            })
          } catch (error) {
            console.error('Error creating YouTube player:', error)
            document.body.removeChild(tempDiv)
          }
        } else {
          setTimeout(() => {
            if (this.videoLink === videoUrl) {
              this.fetchVideoDuration(videoUrl)
            }
          }, 500)
        }
      })
    },
    formatDuration(seconds) {
      if (!seconds || isNaN(seconds)) return ''
      
      const minutes = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      
      return `${minutes}m ${secs}s`
    },
    // showVideoModal(title, videoLink, description, time) {
      
    //   this.showTutorialModal = true;
      
    //   this.title = title;
    //   this.videoLink = videoLink;
    //   this.description = description;
    //   this.time = time;
    // }
  }

}
</script>


<style scoped lang="scss">
.tutorial-video {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  max-width: calc(100vw - 50px);
  padding: 15px;
  border-radius: 6.622px;
  background: var(--v-cardBg-base);
  z-index: 100;
  box-shadow: 0px 6px 27px 0px rgba(0, 0, 0, 0.17);
  
  .close-icon {
    position: absolute;
    right: 0;
    top: 0;
    width: 30px;
    height: 30px;
    transform: translate(50%, -50%);
    background: white;
    border-radius: 100%;
    box-shadow: 0px 6px 27px 0px rgba(0, 0, 0, 0.17);
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .material-icons {
      font-size: 1.3rem;
      color: var(--v-gray2Color-base);
    }
  }
  .video {
    height: 370px;
    background: gray;
    iframe {
      width: 100%;
      height: 100%;
    }
  }
  .video-title {
    font-size: 1.2rem;
    font-weight: 800;
    color: var(--v-mainColor-base);
  }
  .video-time {
    color: var(--v-red12Color-base);
  }
  .video-explain {
    color: var(--v-mainColor-base);
    white-space: pre-line;
  }
}

</style>